import _ from 'lodash';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { QUANT_CONFIG_ORDER_TYPES } from 'v2/common/constants/index';
import { useFormContext, Controller } from 'react-hook-form';
import classNames from 'classnames';
import ActionTypeSelector from './ActionTypeSelector';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import ErrorMesssage from 'v2/common/components/ErrorMessage/index';

const propTypes = {
  actionTimeInSeconds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  action: PropTypes.string,
  orderType: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
  isExitOrder: PropTypes.bool.isRequired
};

const defaultProps = {
  actionTimeInSeconds: '',
  action: ''
};

const ModifyOrCancelOrder = ({
  action: propsAction,
  actionTimeInSeconds: propsActionTimeInSeconds,
  isExitOrder,
  orderType,
  onUpdate
}) => {
  const [action, setAction] = useState(propsAction);

  const { errors, clearErrors, control, getValues } = useFormContext();

  const [modifySecondsName] = useState(isExitOrder ? 'exitActionTimeInSeconds' : 'entryActionTimeInSeconds');

  const errorMessage = _.get(errors, `${modifySecondsName}.message`, '');

  useEffect(() => {
    return () => {
      clearErrors(modifySecondsName);
    };
  }, [clearErrors, modifySecondsName]);

   if (orderType === QUANT_CONFIG_ORDER_TYPES.market.value) {
    return null;
  }

  const onChangeAction = (value) => {
    setAction(value);

    const seconds = Number(getValues(modifySecondsName));

    if (seconds > 0) {
      onUpdate({
        action: value,
        actionTimeInSeconds: seconds
      });
    }
  };

  const renderTitle = (ApplicationDomainUtility?.isAlgoverse || ApplicationDomainUtility?.isQubit)
    ? `${_.capitalize(action)} if order not executed in`
    : 'If order not executed in';


  return (
    <ErrorMesssage message={errorMessage}>
      <div className="modify-orders mt-4">
        <div className="position-relative">
          <div className="d-flex align-items-center flex-wrap gap-5">
            <label className="mb-0 text-nowrap col-form-label col-form-label-sm">
              {renderTitle}
            </label>

            <div className="position-relative d-flex gap-5 align-items-center flex-warp">
              <Controller
                name={modifySecondsName}
                control={control}
                defaultValue={propsActionTimeInSeconds || ''}
                rules={{
                  required: 'value required',
                  pattern: {
                    value: /^\d+$/,
                    message: 'Only digits allowed'
                  }
                }}
                render={(fieldProps) => (
                  <input
                    {...fieldProps}
                    type="text"
                    className={classNames(
                      'form-control seconds-input',
                      { 'border border-danger': !!errors?.[modifySecondsName] }
                    )}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '');

                      fieldProps.onChange(value);

                      onUpdate({
                        action,
                        actionTimeInSeconds: Number(value)
                      });
                    }}
                  />
                )}
              />
            </div>

            <label className="mb-0 col-form-label col-form-label-sm">
              seconds
            </label>

            <ActionTypeSelector
              action={action}
              isHideCancel={isExitOrder}
              onChange={onChangeAction}
            />
          </div>
        </div>
      </div>
    </ErrorMesssage>
  );
};

ModifyOrCancelOrder.propTypes = propTypes;
ModifyOrCancelOrder.defaultProps = defaultProps;

export default ModifyOrCancelOrder;
